import { createContext } from "react"

export interface SupportPartnerInterface {
  _id: string,
  amount: number, 
  createdAt: string,
  updatedAt: string,
}

export const DefaultSupportPartnerInterface: SupportPartnerInterface = {
  _id: "",
  amount: 0, 
  createdAt: "",
  updatedAt: "",
}

export interface PartnerInterface {
  _id: string,
  name: string;
  role: string;
  image: string;
  support: SupportPartnerInterface[]
}

export const DefaultPartnerInterface: PartnerInterface =  {
  _id: "",
  name: "",
  role: "",
  image: "",
  support: [DefaultSupportPartnerInterface]
}


export interface ShowPartnersInterface {
  showSuccessMsg: boolean,
  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean,
  setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean,
  setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, 
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedPartner:PartnerInterface,
  setSelectedPartner: (selectedPartner:PartnerInterface) => void,
  selectedDoctor: any,
  setSelectedDoctor: (selectedDoctor: any) => void,
  hideDataPartner: boolean,
  setHideDataPartner: (hideDataPartner: boolean) => void,
}

export const DefaultShowPartnersInterface:ShowPartnersInterface = {
  showSuccessMsg: false,
  setShowSuccessMsg: () => {},
  showAddModal: false,
  setShowAddModal: () => {},
  showEditModal: false,
  setShowEditModal: () => {},
  showDeleteModal: false, 
  setShowDeleteModal: () => {},
  selectedPartner: DefaultPartnerInterface,
  setSelectedPartner: () => {},
  selectedDoctor: {},
  setSelectedDoctor: () => {},
  hideDataPartner: false,
  setHideDataPartner: () => {},
}

export const ShowPartnersContext = createContext(DefaultShowPartnersInterface)


export interface DataPartnerInterface {
  name: string, setName: (name: string) => void,
  role: string, setRole: (role: string) => void,
  image: File | any, setImage: (image: File | any) => void,
}

export const DefaultDataPartnerInterface: DataPartnerInterface = {
  name: "", setName: () => {},
  role: "", setRole: () => {},
  image: null, setImage: () => {},
}

export const DataPartnerContext = createContext(DefaultDataPartnerInterface)
